<!-- Loader -->

<router-outlet></router-outlet>
